<div class="proposals-list" [class.proposals-list--cards]="cardMode"
    [class.proposals-list--overview]="showOverview && !showDeletedInfo" [class.proposals-list--compact]="compact">

    <!-- ORCA-1965: indicadores no topo, sobre a faixa azul que continua atrás do início da tabela.
         ORCA-1977: só informam; não filtram a lista (os filtros são os chips de status) -->
    <div class="pl-hero" *ngIf="showOverview && !showDeletedInfo">
        <div class="pl-kpis" role="group" aria-label="Indicadores dos orçamentos">
            <ng-container *ngIf="userPreferences$ | async as preferences">
                <div class="pl-kpi">
                    <span class="pl-kpi__label"><mat-icon aria-hidden="true" class="pl-kpi__icon pl-kpi__icon--info">hourglass_top</mat-icon>Aguardando resposta</span>
                    <b class="pl-kpi__value" [class.blurred]="preferences.hide_dashboard_values">{{ kpiValue('awaiting') }}</b>
                    <span class="pl-kpi__sub">{{ plural(kpiCount('awaiting'), 'orçamento enviado', 'orçamentos enviados') }}</span>
                </div>
                <div class="pl-kpi">
                    <span class="pl-kpi__label"><mat-icon aria-hidden="true" class="pl-kpi__icon pl-kpi__icon--warn">warning</mat-icon>Vencem em até 3 dias</span>
                    <b class="pl-kpi__value">{{ kpiValue('expiring') }}</b>
                    <span class="pl-kpi__sub">Lembre o cliente antes que expirem</span>
                </div>
                <div class="pl-kpi">
                    <span class="pl-kpi__label"><mat-icon aria-hidden="true" class="pl-kpi__icon pl-kpi__icon--ok">thumb_up</mat-icon>Aprovados em {{ monthName }}</span>
                    <b class="pl-kpi__value" [class.blurred]="preferences.hide_dashboard_values">{{ kpiValue('approved_month') }}</b>
                    <span class="pl-kpi__sub">{{ plural(kpiCount('approved_month'), 'orçamento', 'orçamentos') }}</span>
                </div>
                <div class="pl-kpi">
                    <span class="pl-kpi__label"><mat-icon aria-hidden="true" class="pl-kpi__icon pl-kpi__icon--info">payments</mat-icon>A receber</span>
                    <b class="pl-kpi__value" [class.blurred]="preferences.hide_dashboard_values">{{ kpiValue('receivable') }}</b>
                    <span class="pl-kpi__sub">{{ plural(kpiCount('receivable'), 'orçamento faturado', 'orçamentos faturados') }}</span>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="pl-panel">
        <!-- ORCA-1965: filtros por status com contagem -->
        <div class="pl-toolbar" *ngIf="showOverview && !showDeletedInfo">
            <div class="oa-chip-row pl-chips" role="group" aria-label="Filtrar por status">
                <button type="button" class="oa-chip oa-chip--toggle" *ngFor="let chip of statusChips"
                    [attr.aria-pressed]="statusChip === chip.key && !situation" (click)="pickStatus(chip.key)">
                    <span class="oa-chip__label">{{ chip.label }}</span>
                    <small *ngIf="chipCount(chip.key) !== ''" class="oa-chip__count">{{ chipCount(chip.key) }}</small>
                </button>
            </div>
        </div>

        <!-- ORCA-1968: filtros rápidos da Início -->
        <div class="pl-quick" *ngIf="compact">
            <div class="oa-chip-row pl-chips" role="group" aria-label="Filtrar últimos orçamentos">
                <button type="button" class="oa-chip oa-chip--toggle" [attr.aria-pressed]="!situation && statusChip === 'all'"
                    (click)="pickStatus('all')">
                    <span class="oa-chip__label">Todos</span>
                    <small *ngIf="chipCount('all') !== ''" class="oa-chip__count">{{ chipCount('all') }}</small>
                </button>
                <button type="button" class="oa-chip oa-chip--toggle" [attr.aria-pressed]="situation === 'awaiting'"
                    (click)="pickSituation('awaiting')">
                    <span class="oa-chip__label">Aguardando resposta</span>
                    <small *ngIf="situationCount('awaiting') !== ''" class="oa-chip__count">{{ situationCount('awaiting') }}</small>
                </button>
                <button type="button" class="oa-chip oa-chip--toggle" [attr.aria-pressed]="situation === 'expiring'"
                    (click)="pickSituation('expiring')">
                    <span class="oa-chip__label">Vencem em 3 dias</span>
                    <small *ngIf="situationCount('expiring') !== ''" class="oa-chip__count">{{ situationCount('expiring') }}</small>
                </button>
            </div>
        </div>

        <!-- ORCA-1967: barra da seleção (lembrar clientes, alterar status, exportar e excluir) -->
        <div class="bulk-action-bar" *ngIf="bulkActionsEnabled && pageSelection && hasBulkSelection() && !cardMode"
            role="region" aria-label="Ações dos orçamentos selecionados">
            <div class="bulk-selection-summary">
                {{ getSelectedCount() === 1 ? '1 orçamento selecionado' : getSelectedCount() + ' orçamentos selecionados' }}
            </div>
            <div class="bulk-action-buttons">
                <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" (click)="remindSelected()"
                    [disabled]="selectedSentCount() === 0"
                    [matTooltip]="selectedSentCount() === 0 ? 'Só orçamentos enviados podem ser lembrados' : 'Cria um lembrete nas suas notificações (o cliente não recebe nada)'">
                    <mat-icon>notifications_active</mat-icon>
                    <span>Lembrar clientes</span>
                </button>
                <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" [matMenuTriggerFor]="statusMenu">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Alterar status</span>
                </button>
                <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" (click)="exportSelected()">
                    <mat-icon>file_download</mat-icon>
                    <span>Exportar</span>
                </button>
                <button type="button" class="oa-btn oa-btn--sm oa-btn--danger-ghost" (click)="deleteSelected()">
                    <mat-icon>delete</mat-icon>
                    <span>Excluir</span>
                </button>
                <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" (click)="clearSelection()">
                    <mat-icon>clear</mat-icon>
                    <span>Limpar seleção</span>
                </button>
            </div>
            <mat-menu #statusMenu="matMenu" class="oa-actions-menu">
                <button mat-menu-item *ngFor="let option of bulkStatuses" (click)="changeSelectedStatus(option.status, option.label)">
                    <app-proposal-status-badge [status]="option.status" size="sm"></app-proposal-status-badge>
                </button>
            </mat-menu>
        </div>

        <div class="bulk-action-bar" *ngIf="bulkActionsEnabled && !pageSelection && hasBulkSelection()">
            <div class="bulk-selection-summary">
                Selecionados: {{ getSelectedCount() }} / {{ getTotalCount() }}
            </div>
            <div class="bulk-action-buttons">
                <button type="button" class="oa-btn oa-btn--sm oa-btn--ghost" (click)="clearSelection()">
                    <mat-icon>clear</mat-icon>
                    <span>Limpar seleção</span>
                </button>
                <button type="button" class="oa-btn oa-btn--sm"
                    [ngClass]="bulkActionMode === 'restore' ? 'oa-btn--primary' : 'oa-btn--danger-ghost'"
                    (click)="confirmBulkAction()">
                    <mat-icon>{{ bulkActionIcon }}</mat-icon>
                    <span>{{ bulkActionLabel }}</span>
                </button>
            </div>
        </div>

        <app-table #proposalsList matSort [sort]="sort" matSortActive="updated_at" matSortDisableClear
            matSortDirection="desc" [dataSource]="dataSource" [displayedColumns]="displayedColumns"
            [searchField]="searchField" [filterFieldComponent]="filterFieldComponent" searchFieldName="search"
            filterFieldName="filters" [pageSizeOptions]="[8, 10, 50, 100, 200]" [pageSize]="pageSize"
            (onTableUpdate)="onTableUpdate($event)" (onSelectedRow)="onSelectedRow($event)"
            (onSortChange)="onSortChange($event)" [rememberPageSize]="variant === 'table'" paginationKey="proposals"
            [reserveSpaceOnFirstLoad]="true" [trackBy]="trackByProposalId">

            <ng-container *ngIf="bulkActionsEnabled" matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="select-column">
                    <div class="bulk-cell">
                        <orca-input type="checkbox" size="small">
                            <input type="checkbox" (click)="$event.stopPropagation()" (change)="masterToggle()"
                                [checked]="isAllSelected()" [class.indeterminate]="isSomeSelected()"
                                aria-label="Selecionar todos">
                        </orca-input>
                    </div>
                </th>
                <td mat-cell *matCellDef="let proposal" class="select-column">
                    <div class="bulk-cell">
                        <orca-input type="checkbox" size="small">
                            <input type="checkbox" (click)="$event.stopPropagation()" (change)="toggleSelection(proposal)"
                                [checked]="isSelected(proposal)"
                                [attr.aria-label]="'Selecionar orçamento #' + proposal.proposalNumber">
                        </orca-input>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef class="pl-col-avatar"></th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-avatar">
                    <ngx-avatar [size]="34" [round]="true" initialsSize="2" [name]="proposal.client?.name"
                        [src]="proposal.client?.image"></ngx-avatar>
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="short_description">Orçamento</th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-description">
                    <ng-container *ngTemplateOutlet="identity; context: { $implicit: proposal }"></ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-col-status">Status</th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-status">
                    <ng-container *ngTemplateOutlet="statusBadge; context: { $implicit: proposal }"></ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="total_liquid" class="pl-col-value">Valor</th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-value">
                    <ng-container *ngIf="userPreferences$ | async as preferences">
                        <span class="pl-value" [class.blurred]="preferences.hide_dashboard_values"
                            [attr.aria-hidden]="preferences.hide_dashboard_values ? 'true' : null">
                            <b>R$ {{ currencyFormatte(proposal.totalLiquid) }}</b>
                            <span class="pl-value__payment" *ngIf="proposal.paymentSummary">{{ proposal.paymentSummary }}</span>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="situacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="updated_at" class="pl-col-situation">
                    Validade / situação e atividade</th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-situation">
                    <span class="pl-situation" *ngIf="situationOf(proposal) as s">
                        <span class="pl-due pl-due--{{ s.tone }}">
                            <mat-icon aria-hidden="true">{{ s.icon }}</mat-icon>{{ s.full }}
                        </span>
                        <span class="pl-activity" *ngIf="activityOf(proposal)">{{ activityOf(proposal) }}</span>
                        <!-- ORCA-1972: data de criação (a última atividade já diz quando mudou) -->
                        <span class="pl-updated" *ngIf="createdOf(proposal)">{{ createdOf(proposal) }}</span>
                        <span class="pl-updated pl-deleted-info" *ngIf="showDeletedInfo && proposal.deletedAt">
                            Excluído em {{ proposal.deletedAt | date:'short' }}
                        </span>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef class="pl-col-actions">Ações</th>
                <td mat-cell *matCellDef="let proposal" class="pl-col-actions">
                    <ng-container *ngTemplateOutlet="actions; context: { $implicit: proposal }"></ng-container>
                </td>
            </ng-container>

            <!-- ORCA-1968/1969: card em duas partes — identidade (com "Atualizado há X") e faixa com
                 status e valor à esquerda e as ações à direita. Sem o campo de validade/situação,
                 para o card ficar mais baixo e caberem mais orçamentos por dobra. -->
            <ng-container matColumnDef="card">
                <th mat-header-cell *matHeaderCellDef class="pl-card-header"></th>
                <td mat-cell *matCellDef="let proposal" class="pl-card-cell">
                    <article class="pl-card" [class.pl-card--selected]="isSelected(proposal)">
                        <div class="pl-card__identity">
                            <ngx-avatar [size]="36" [round]="true" initialsSize="2" [name]="proposal.client?.name"
                                [src]="proposal.client?.image"></ngx-avatar>
                            <span class="pl-card__main">
                                <ng-container *ngTemplateOutlet="identity; context: { $implicit: proposal }"></ng-container>
                                <span class="pl-updated">{{ updatedOf(proposal) }}</span>
                            </span>
                        </div>
                        <div class="pl-card__footer">
                            <span class="pl-card__meta">
                                <ng-container *ngTemplateOutlet="statusBadge; context: { $implicit: proposal }"></ng-container>
                                <b *ngIf="userPreferences$ | async as preferences" class="pl-card__value"
                                    [class.blurred]="preferences.hide_dashboard_values"
                                    [attr.aria-hidden]="preferences.hide_dashboard_values ? 'true' : null">
                                    R$ {{ currencyFormatte(proposal.totalLiquid) }}
                                </b>
                            </span>
                            <ng-container *ngTemplateOutlet="actions; context: { $implicit: proposal }"></ng-container>
                        </div>
                    </article>
                </td>
            </ng-container>

            <ng-template #emptyTemplate>
                <div class="empty-view">
                    <div class="empty-view-title">
                        {{
                        (dataSource.noRecords | async) ? 'Crie Seu Primeiro Orçamento' : 'Nenhum orçamento encontrado'
                        }}
                    </div>

                    <div class="empty-view-subtitle">
                        {{
                        (dataSource.noRecords | async) ?
                        'Você ainda não criou nenhum orçamento. Clique no botão abaixo e comece agora, é muito fácil!' :
                        'Não encontramos orçamentos com os filtros aplicados. Tente ajustar seus filtros.'
                        }}
                    </div>

                    <div class="container-btn">
                        <button type="button" class="oa-btn oa-btn--cta" (click)="newProposal(true)">
                            <mat-icon>add_circle</mat-icon>
                            <span>Criar orçamento</span>
                        </button>
                    </div>

                    <div class="container-img">
                        <img style="max-height: 303px;" src="/assets/images/ilustrations/first-proposal.png" alt="">
                    </div>
                </div>
            </ng-template>
        </app-table>

        <a *ngIf="compact" class="pl-see-all" [routerLink]="['/propostas']">
            Ver todos os orçamentos<mat-icon aria-hidden="true">arrow_forward</mat-icon>
        </a>
    </div>
</div>

<!-- Nº + título e cliente (sem cortar), selo do pedido de cotação e tags -->
<ng-template #identity let-proposal>
    <span class="pl-identity">
        <span class="pl-identity__title">
            <b class="pl-identity__number">#{{ proposal.proposalNumber }}</b><span class="pl-identity__sep" *ngIf="proposal.shortDescription"> – </span><b>{{ proposal.shortDescription }}</b>
        </span>
        <span class="pl-identity__client" *ngIf="showClient || showCustomer">
            <ng-container *ngIf="showClient">{{ proposal.client?.name }}</ng-container>
            <ng-container *ngIf="showCustomer && proposal.customer?.name"><ng-container *ngIf="showClient"> · </ng-container>por {{ proposal.customer?.name }}</ng-container>
        </span>
        <span class="pl-marks" *ngIf="hasMarks(proposal)" aria-label="Origem e tags">
            <span class="pl-quote" *ngIf="proposal.cotacaoId"
                matTooltip="Veio de um pedido de cotação que o cliente fez pela página da empresa">
                <mat-icon aria-hidden="true">storefront</mat-icon>{{ quoteLabelOf(proposal) }}
            </span>
            <span class="pl-tag" *ngFor="let tag of proposal.tags" [ngStyle]="tagStyle(tag?.hexadecimalColor)">
                <span class="pl-tag__dot" [style.background-color]="tagDot(tag?.hexadecimalColor)"></span>{{ tag?.name }}
            </span>
        </span>
    </span>
</ng-template>

<!-- Status (badge de 96 px com as cores do app) e "Excluído" -->
<ng-template #statusBadge let-proposal>
    <span class="pl-status">
        <app-proposal-status-badge [status]="badgeStatus(proposal)" size="sm"
            [fallbackLabel]="isDeleted(proposal) ? '' : proposal.statusName"></app-proposal-status-badge>
        <span *ngIf="isDeleted(proposal)" class="oa-badge oa-badge--deleted">Excluído</span>
    </span>
</ng-template>

<!-- Ações visíveis só com ícone: Aprovar e Reprovar nos enviados (ORCA-1972); a ação principal do
     status nos demais. As outras ficam no ⋮. -->
<ng-template #actions let-proposal>
    <span class="pl-actions" (click)="$event.stopPropagation()">
        <ng-container *ngIf="bulkActionMode === 'restore'; else defaultActions">
            <button type="button" class="oa-btn oa-btn--sm oa-btn--secondary" (click)="restoreProposal($event, proposal)">
                <mat-icon>restore_from_trash</mat-icon>
                <span>Restaurar</span>
            </button>
        </ng-container>
        <ng-template #defaultActions>
            <button *ngIf="isSent(proposal)" type="button" class="pl-approve" matTooltip="Aprovar"
                [attr.aria-label]="'Aprovar orçamento #' + proposal.proposalNumber"
                (click)="runQuickAction($event, approveButton, proposal, act)">
                <mat-icon>thumb_up</mat-icon>
            </button>
            <button *ngIf="isSent(proposal)" type="button" class="pl-approve pl-approve--refuse" matTooltip="Reprovar"
                [attr.aria-label]="'Reprovar orçamento #' + proposal.proposalNumber"
                (click)="runQuickAction($event, refuseButton, proposal, act)">
                <mat-icon>thumb_down</mat-icon>
            </button>

            <ng-container *ngIf="mainAction(proposal) as main">
                <!-- Enviar abre as formas de envio do ⋮ -->
                <button *ngIf="main.action === 'enviar'; else mainButton" type="button"
                    class="oa-icon-btn oa-icon-btn--secondary pl-icon-action" [matTooltip]="main.label"
                    [matMenuTriggerFor]="act.sendMenu" [attr.aria-label]="'Enviar orçamento #' + proposal.proposalNumber">
                    <mat-icon svgIcon="send-plane"></mat-icon>
                </button>
                <ng-template #mainButton>
                    <button type="button" class="oa-icon-btn oa-icon-btn--secondary pl-icon-action" [matTooltip]="main.label"
                        [attr.aria-label]="main.label + ' do orçamento #' + proposal.proposalNumber"
                        (click)="runQuickAction($event, main, proposal, act)">
                        <mat-icon>{{ main.icon }}</mat-icon>
                    </button>
                </ng-template>
            </ng-container>

            <button type="button" class="oa-icon-btn pl-icon-action" [matMenuTriggerFor]="act.moreMenu"
                matTooltip="Mais ações" [attr.aria-label]="'Mais ações do orçamento #' + proposal.proposalNumber">
                <mat-icon>more_vert</mat-icon>
            </button>

            <app-proposal-actions [proposal]="proposal" #act="menuInOtherComponent"
                (onProposalChanged)="reload()" (onStatusAction)="onStatusAction($event, proposal)"
                (onProposaDeleted)="handleProposalDeleted()"></app-proposal-actions>
        </ng-template>
    </span>
</ng-template>
